import AssetLogo from "./asset-logo";

export default function TeamLogo({ teamId, size = 40, className = '' }: { teamId: number, size?: number, className?: string }) {
    return (
        <AssetLogo
            id={teamId}
            folder="teams"
            alt="team logo"
            size={size}
            className={className}
        />
    );
}